export const ATTACHMENT_FILE_TYPES = Object.freeze({ IMAGE: 1, PDF: 2, VIDEO: 3, YOUTUBE: 4 })
